// Ensure jQuery types are available
import $ from "jquery";

interface AjaxResponse {
  status: number;
  message: string;
}

interface MyScriptVars {
  postID: number;
  [key: string]: any;
}

// Extend Window interface to include your custom vars
declare global {
  interface Window {
    my_script_vars: MyScriptVars;
  }
}

$(document).ready(function (): void {
  console.log("hello from js");

  const $openSearch: JQuery<HTMLElement> = $(".open_search");
  const $searchForm: JQuery<HTMLElement> = $(".search_form");
  const $primaryNavSearch: JQuery<HTMLElement> = $(
    "#primary_nav_search_input_box"
  );

  $openSearch.on("click", function (): void {
    if ($searchForm.css("display") === "none") {
      $searchForm.show("slow");
      $primaryNavSearch.trigger("focus");
    } else {
      $searchForm.hide("slow");
    }
  });

  const $subscriptionBtn: JQuery<HTMLButtonElement> = $("#subscription_btn");
  const $subscriptionForm: JQuery<HTMLFormElement> = $("#subscription-form");
  const $subscriptionEmail: JQuery<HTMLInputElement> = $("#subscription_email");
  const $subscriptionBot: JQuery<HTMLInputElement> = $("#subscription-bot");
  const $emailValidationMsg: JQuery<HTMLElement> = $(
    ".subscription-email-validation-message"
  );
  const $ajaxResponse: JQuery<HTMLElement> = $("#ajax-response");

  function disableSubscriptionButton(): void {
    $subscriptionBtn.prop("disabled", true);
    $subscriptionBtn.css("cursor", "not-allowed");
  }

  function enableSubscriptionButton(): void {
    $subscriptionBtn.prop("disabled", false);
    $subscriptionBtn.css("cursor", "pointer");
    $subscriptionBtn.html("Subscribe");
  }

  const emailRegex: RegExp =
    /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

  $subscriptionForm.on("submit", function (e: JQuery.Event): void {
    e.preventDefault();
    disableSubscriptionButton();

    const email: string = $.trim($subscriptionEmail.val() as string);
    const subscriptionBot: string = $.trim($subscriptionBot.val() as string);

    if (email === "") {
      $emailValidationMsg
        .text("Email is required.")
        .addClass("invalid-feedback");
      enableSubscriptionButton();
    } else if (!emailRegex.test(email)) {
      $emailValidationMsg
        .text("Invalid email format.")
        .addClass("invalid-feedback");
      enableSubscriptionButton();
    } else {
      $emailValidationMsg.text("").removeClass("invalid-feedback");
      const url: string = $subscriptionForm.attr("action") || "";
      const form: Array<{ name: string; value: string }> =
        $subscriptionForm.serializeArray();

      $.ajax({
        url: url,
        method: "POST",
        data: form,
        beforeSend: function (): void {
          $subscriptionBtn.html(
            '<i class="fas fa-spinner fa-spin"></i> Subscribing...'
          );
          disableSubscriptionButton();
          $ajaxResponse.removeClass("alert-danger alert-success");
        },
        success: function (response: string): void {
          const parsedResponse: AjaxResponse = JSON.parse(response);

          if (parsedResponse.status === 1) {
            $emailValidationMsg.text(parsedResponse.message);
          } else {
            $emailValidationMsg.text(parsedResponse.message);
          }

          enableSubscriptionButton();
        },
        error: function (
          xhr: JQuery.jqXHR,
          status: string,
          error: string
        ): void {
          console.error("AJAX Error:", status, error);
          enableSubscriptionButton();
        },
      });
    }
  });

  // Header scroll behavior
  let didScroll: boolean = false;
  let lastScrollTop: number = 0;
  const delta: number = 5;
  const navbarHeight: number = $("header").outerHeight() || 0;

  $(window).on("scroll", function (): void {
    didScroll = true;
  });

  setInterval(function (): void {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled(): void {
    const st: number = $(window).scrollTop() || 0;

    if (Math.abs(lastScrollTop - st) <= delta) return;

    if (st > lastScrollTop && st > navbarHeight) {
      $("header").removeClass("nav-down").addClass("nav-up");
    } else {
      if (st + $(window).height()! < $(document).height()!) {
        $("header").removeClass("nav-up").addClass("nav-down");
      }
    }
    lastScrollTop = st;
  }
});

$(window).on("load scroll", function (): void {
  const MyPostID: number = window.my_script_vars?.postID || 0;
  const $mainMenuLinks: JQuery<HTMLElement> = $(".main_menu li a");
  const $openSearchIcon: JQuery<HTMLElement> = $(".open_search i");
  const $themeBlueElements: JQuery<HTMLElement> = $(".theme-blue");

  if ([7, 2, 11].includes(MyPostID)) {
    $mainMenuLinks.css("color", "#ffffff");
    $themeBlueElements.css("color", "#ffffff");
  } else {
    $mainMenuLinks.css("color", "#000000");
    $openSearchIcon.css("color", "#000000");
    $themeBlueElements.css("color", "#000000");
  }
  console.log(MyPostID, "pageID Wp");
});

$(document).ready(function (): void {
  const $certificationIcons: JQuery<HTMLElement> = $(
    ".certificationCls .guten-social-icon"
  );
  $certificationIcons.find("i").remove();
  $certificationIcons.prepend(
    '<a class="orangeBtnCls" href="/our-quality/">LEARN MORE</a>'
  );
});
